/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum TipoChamadoAliases {
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_CATEGORIES = 'deck-categories',
  FETCH_CATEGORIES = 'fetch-categories',
  FIELD_CATEGORY_NAME = 'field-category-name',
  HPMS_CUSTOM_CARD_CATEGORY = 'hpms-custom-card-category',
  PANEL_0 = 'panel-0',
  TEXT_2 = 'text-2',
}
export { TipoChamadoAliases };
